export const MAX_COMPARE_SPOTS = 4;

export const normalizeCompareIds = (value) => {
  const items = Array.isArray(value) ? value : String(value || "").split(",");
  const seen = new Set();
  const ids = [];
  for (const item of items) {
    const id = String(item || "").trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
    if (ids.length === MAX_COMPARE_SPOTS) break;
  }
  return ids;
};

export const buildComparePath = (spots, { searchCenter, returnTo, date } = {}) => {
  const ids = normalizeCompareIds((spots || []).map((spot) => typeof spot === "string" ? spot : spot?.id));
  const params = new URLSearchParams();
  if (ids.length) params.set("spots", ids.join(","));

  if (searchCenter && Number.isFinite(searchCenter.lat) && Number.isFinite(searchCenter.lng)) {
    params.set("lat", String(searchCenter.lat));
    params.set("lng", String(searchCenter.lng));
    if (searchCenter.name) params.set("place", searchCenter.name);
  }

  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    params.set("date", date);
  }

  if (returnTo && returnTo.startsWith("/") && !returnTo.startsWith("//")) {
    params.set("from", returnTo);
  }

  const query = params.toString();
  return query ? `/compare?${query}` : "/compare";
};

export const compareOriginFromSearchParams = (searchParams) => {
  const rawLat = searchParams.get("lat");
  const rawLng = searchParams.get("lng");
  if (rawLat == null || rawLng == null || rawLat.trim() === "" || rawLng.trim() === "") return null;
  const lat = Number(rawLat);
  const lng = Number(rawLng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return {
    lat,
    lng,
    name: searchParams.get("place")?.trim() || "",
  };
};

export const compactDayTicketLabel = (value) => {
  const text = String(value || "").trim();
  if (!text) return null;

  const prefixedEuro = text.match(/^€\s*(\d+(?:[.,]\d{1,2})?)/i);
  if (prefixedEuro) return `${prefixedEuro[1]} €`;

  const suffixedEuro = text.match(/(\d+(?:[.,]\d{1,2})?)\s*(?:EUR|€)/i);
  if (suffixedEuro) return `${suffixedEuro[1]} €`;

  return null;
};
